
import Vue from 'vue'
import Vuex from 'vuex'
import equipment from "./modules/equipment";
import common from "./modules/common";
import getters from './getters'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    equipment,
    common,
    // user,
    // config
  },
  getters


})



// WEBPACK FOOTER //
// ./src/store/index.js